module.exports = "/_next/static/images/collaborate-mobile-bd736d42d3dc953a433ebfdc7f983e30.png";